import type { SRT_Row, SRT_RowData, SRT_TableInstance } from '../types'

export type CustomRowSelectionRow = {
	toggleTreeSelected: () => boolean
}
export type CustomRowSelectionInstance = {
	toggleAllTreeRowsSelected: () => void
	getIsAllTreeRowsSelected: () => void
}
export const CustomRowSelection = {
	createTable: <TData extends SRT_RowData>(
		table: SRT_TableInstance<TData>
	): void => {
		table.toggleAllTreeRowsSelected = (value: boolean) => {
			table.getRowModel().rows.forEach((row) => {
				if (!row.subRows?.length) {
					row.toggleSelected(value)
				}
				if (row.getCanSelectSubRows()) {
					for (const r of row.subRows ?? []) {
						r.toggleSelected(value)
					}
				}
			})
		}
		table.getIsAllTreeRowsSelected = () => {
			const paginationFlatRows = table
				.getPaginationRowModel()
				.flatRows.filter((row) => row.getCanSelect() && !row.subRows?.length)

			const { rowSelection } = table.getState()

			let isAllPageRowsSelected = !!paginationFlatRows.length

			if (
				isAllPageRowsSelected &&
				paginationFlatRows.some((row) => !rowSelection[row.id])
			) {
				isAllPageRowsSelected = false
			}

			return isAllPageRowsSelected
		}
	},
	createRow: <TData extends SRT_RowData>(
		row: SRT_Row<TData>,
		table: SRT_TableInstance<TData>
	) => {
		row.toggleTreeSelected = (value: boolean) => {
			if (table.options.selectAllMode === 'tree') {
				if (!row.subRows?.length) {
					row.toggleSelected(value)
				}
				if (row.getCanSelectSubRows() && !row.getIsAllSubRowsSelected()) {
					for (const r of row.subRows ?? []) {
						r.toggleSelected(true)
					}
				}
			}
		}
	},
}
